var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useReducer } from 'react';
import { getLanguageFromStorage } from 'syf-js-utilities';
import { resetAnswers, setAnswer, setIndex, setQuestions } from '../actions/questionnaire';
import { Flows, Routes } from '../const';
import { useMainContext } from '../context';
import { questionnaireReducer } from '../reducers/questionnaire';
import { LANG } from '../sandbox/const/sandbox-consts';
import usePlanQuestionnaireQuery from './use-plan-questionnaire';
import useSettlementQuestionnaireQuery from './use-settlement-questionnaire';
export var useQuestionnaire = function (flow) {
    var currentLanguage = getLanguageFromStorage();
    var currentRoute = useMainContext().currentRoute;
    var _a = useSettlementQuestionnaireQuery(currentRoute === Routes.SETTLEMENT_START && flow === Flows.SETTLEMENT), settlementData = _a.data, settlementSuccess = _a.isSuccess;
    var _b = usePlanQuestionnaireQuery(currentRoute === Routes.PLAN_START && flow === Flows.PLAN), planData = _b.data, planSuccess = _b.isSuccess;
    var _c = useReducer(questionnaireReducer, {
        questions: [],
        index: 0,
        selectedAnswers: []
    }), questionnaire = _c[0], dispatch = _c[1];
    useEffect(function () {
        if ((currentRoute === Routes.SETTLEMENT_START && settlementSuccess) ||
            currentRoute === Routes.PLAN_START ||
            planSuccess) {
            var questionnaireData = void 0;
            if (currentRoute.includes(Flows.SETTLEMENT)) {
                questionnaireData = settlementData;
            }
            else if (currentRoute.includes(Flows.PLAN)) {
                questionnaireData = planData;
            }
            var questionnaireForSelectedLanguage = currentLanguage === LANG.ES
                ? questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.questionnaireES
                : questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.questionnaireEN;
            var mappedResponse = questionnaireForSelectedLanguage === null || questionnaireForSelectedLanguage === void 0 ? void 0 : questionnaireForSelectedLanguage.map(function (question) { return (__assign(__assign({}, question), { subheading: question.questionSubheading, footnoteText: question.footNoteText, answers: question.answers.map(function (answer) { return (__assign(__assign({}, answer), { questionId: question.questionId })); }) })); });
            if (mappedResponse) {
                // Don't run if mappedResponse is undefined
                dispatch(setQuestions(mappedResponse));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLanguage, settlementSuccess, planSuccess, currentRoute]);
    var onSelectAnswer = function (answer) {
        dispatch(setAnswer(answer));
    };
    var onSetQuestions = function (questions) {
        dispatch(setQuestions(questions));
    };
    var setQuestionIndex = function (question) {
        dispatch(setIndex(question));
    };
    var onResetQuestionnaire = function () {
        dispatch(resetAnswers());
    };
    return {
        planData: planData,
        questionnaire: questionnaire,
        onSelectAnswer: onSelectAnswer,
        onSetQuestions: onSetQuestions,
        setQuestionIndex: setQuestionIndex,
        onResetQuestionnaire: onResetQuestionnaire
    };
};
//# sourceMappingURL=use-questionnaire.js.map